import { Injectable } from '@angular/core';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';


@Injectable({
  providedIn: 'root'
})
export class SocketService {

  initSocket () {
    /*
    return new Echo({
      broadcaster: 'pusher',
      key: '41a79fefc98385115ae6',
      wsHost: window.location.hostname,
      wsPort: 6001,
      forceTLS: false,
      disableStats: true,
      enabledTransports: ['ws', 'wss']
    });*/

    return new Pusher('41a79fefc98385115ae6', {
      cluster: 'eu',
      // encrypted: true
    });
    
  }
  
}
